import { getDateFromAppointment } from './getDateFromAppointment'
import { Appointment } from '../../models/appointment/Appointment'
import { Note, NoteStatusStates } from '../../models/notes/Notes'

/**
 * Returns the list of session numbers for past, non-canceled/missed appointments
 * in a given episode that do not yet have a completed note.
 */
export function getSessionsNeedingNotesForEpisode(
  appointments: Appointment[] | undefined | null,
  notes: Note[] | undefined | null,
  episodeId: string | undefined | null,
  now: Date = new Date(),
): number[] {
  if (!episodeId) return []

  const appts = appointments ?? []
  const noteList = notes ?? []

  return appts
    .filter((a) => a.episodeId === episodeId)
    .filter((appt) => {
      const start = getDateFromAppointment(appt)
      return start < now && !['canceled', 'missed'].includes(appt.appointmentStatus)
    })
    .filter(
      (appt) =>
        !noteList.some((n) => n.appointment_id === appt.appointmentId && n.status === NoteStatusStates.COMPLETED),
    )
    .map((appt) => appt.sessionNumber)
    .sort((a, b) => a - b)
}
